import {
  Banknote,
  Calendar,
  CalendarDays,
  CalendarClock,
  Home,
  Images,
  Inbox,
  Landmark,
  Mail,
  Settings,
  ShieldCheck,
  ShoppingBasket,
  Sparkles,
  Star,
  Users,
  type LucideIcon,
} from 'lucide-react'

/**
 * The icon each sidebar entry wears, by its key in `routes.ts`.
 *
 * Shared, not private to the sidebar, because the same things show up elsewhere
 * and must look like themselves: the property calendar draws a deposit event
 * with Protection's icon, a supply event with Supplies' (CAP-913) and a review
 * event with Reviews' (CAP-879).
 */
export const NAV_ICONS: Record<string, LucideIcon> = {
  calendar: CalendarDays,
  inbox: Inbox,
  properties: Home,
  users: Users,
  assets: Images,
  operations: Settings,
  newsletters: Mail,
  protection: ShieldCheck,
  reviews: Star,
  orphanOffers: CalendarClock,
  cleaning: Sparkles,
  taxReports: Landmark,
  supplies: ShoppingBasket,
  uplisting: Calendar,
  clearing: Banknote,
}

export const PROTECTION_ICON = NAV_ICONS.protection
export const SUPPLIES_ICON = NAV_ICONS.supplies
export const REVIEWS_ICON = NAV_ICONS.reviews
